/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const unlock_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#unlock_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M1 10V6.25a5.25 5.25 0 0 1 10.5 0v2.625m3.375 6v3m-7.5-7.5a1.5 1.5 0 0 1 1.5-1.5H21.25a1.5 1.5 0 0 1 1.5 1.5V21.25a1.5 1.5 0 0 1-1.5 1.5H8.875a1.5 1.5 0 0 1-1.5-1.5V10.375Z"
      />
    </g>
    <defs>
      <clipPath id="unlock_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default unlock_medium
